import { IFileMetadataEntity } from "@odata/GeneratedEntityTypes";
import React from "react";

export enum ChatMessageType {
    Received = "Received",
    Sent = "Sent"
}

export interface IChatMessage {
    icon?: React.ReactNode;
    created?: Date;
    createdBy?: string;
    createdById?: number;
    subject?: string;
    text: string;
    type: ChatMessageType;
    attachments?: IFileMetadataEntity[];
}
